<div class="container">
    <div class="wrapper-md">
        <app-breadcrumbs [items]="[
                         { url: '/employee-cards', text: 'employeeCard_listTitle', query: { noRedirect: 'true' } },
                         { text: isNew ? 'employeeCard_newTitle' : title }]"></app-breadcrumbs>

        <header class="content-header">
            <h1>
                {{'employeeCard_title' | translate}}
                <app-employee-card-status *ngIf="status" [value]="status" [description]="revocationReason"></app-employee-card-status>
            </h1>
        </header>

        <div class="content-desc">{{'employeeCard_description' | translate}}</div>

        <app-person-picker *ngIf="isPersonPickerOpened" personType="employee" (pick)="pickPerson($event)"></app-person-picker>

        <app-alert level="danger" *ngIf="staffError && !isPersonPickerOpened">
            <div>{{staffError}}</div>
            <div *ngIf="canPickPerson">
                <a href="#" (click)="$event.preventDefault(); togglePersonPicker()">{{'employeeCard_btnPickAnother' | translate}}</a>
            </div>
        </app-alert>

        <form [formGroup]="form" *ngIf="!isPersonPickerOpened && !isStaffLoading && !staffError">
            <div class="layout" *ngIf="cardProps">
                <div class="e-card-container">
                    <div class="e-card"
                         [class.e-card-flipped]="isFlipped"
                         [style.height]="cardProps.Height + 'px'"
                         [style.width]="cardProps.Width + 'px'">
                        <div class="e-card-front">
                            <img [src]="frontImageUrl" *ngIf="frontImageUrl" class="e-card-mask" />

                            <div #photoBox
                                 class="e-card-photo"
                                 *ngIf="isEdit"
                                 [style.left]="cardProps.AvatarLeft + 'px'"
                                 [style.top]="cardProps.AvatarTop + 'px'"
                                 [style.height]="cardProps.AvatarHeight + 'px'"
                                 [style.width]="cardProps.AvatarWidth + 'px'"
                                 (wheel)="onWheel($event)">

                                <img #photoImg
                                     *ngIf="photoImageUrl"
                                     [src]="photoImageUrl"
                                     [class.vertical]="photoHeight > photoWidth"
                                     [class.horizontal]="photoHeight <= photoWidth"
                                     [style.height]="photoHeightScaled + 'px'"
                                     [style.width]="photoWidthScaled + 'px'"
                                     (mousedown)="onDragStart($event)" />
                            </div>

                            <div class="e-card-info"
                                 [style.left]="cardProps.AvatarLeft + 'px'"
                                 [style.right]="cardProps.AvatarLeft + 'px'"
                                 [style.top]="cardProps.AvatarTop + cardProps.AvatarHeight + 'px'">
                                <div class="e-card-name">
                                    <div>{{isEdit ? form.get('name')?.value : name}}</div>
                                    <div>{{isEdit ? form.get('surname')?.value : surname}}</div>
                                </div>
                                <div class="e-card-employee">
                                    <div class="e-card-structure">{{isEdit ? form.get('structure')?.value : structure}}</div>
                                    <div class="e-card-position">{{isEdit ? form.get('position')?.value : position}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="e-card-back">
                            <img [src]="backImageUrl" *ngIf="backImageUrl" />
                        </div>
                    </div>

                    <div class="text-center mt-1 text-sm">
                        <a (click)="$event.preventDefault(); flip()" href="#">
                            <i class="fi fi-rs-rotate-right"></i>
                            {{(isFlipped ? 'employeeCard_showFront' : 'employeeCard_showBack') | translate}}
                        </a>
                    </div>

                    <div *ngIf="photoImageUrl && !isFlipped" class="mt-2">
                        <input class="form-range"
                               type="range"
                               [min]="minScale"
                               [max]="maxScale"
                               [value]="photoWidthScaled"
                               step="1"
                               (input)="scale(+$event.target.value)" />
                    </div>
                </div>

                <div class="data">
                    <ng-container *ngIf="!isEdit">
                        <app-alert level="warning" *ngIf="revocationReason">{{revocationReason}}</app-alert>

                        <div class="data-value">
                            <label>{{'employeeCard_lblEmployee' | translate}}</label>
                            <div>{{name}} {{surname}} ({{upn}})</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeCard_lblStructurePosition' | translate}}</label>
                            <div>{{structure}} ({{position}})</div>
                        </div>

                        <div class="data-value">
                            <label>{{'employeeCard_lblCardNumber' | translate}}</label>
                            <div>{{cardNumber || '-'}}</div>
                        </div>

                        <div class="data-value" *ngIf="isAdmin">
                            <label>{{'employeeCard_lblChipCode' | translate}}</label>
                            <div>{{chipCode || '-'}}</div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isEdit">
                        <app-alert level="info" *ngIf="requirements">
                            <div [innerHTML]="requirements | safeHtml"></div>
                            <div class="mt-2">
                                <button class="btn btn-outline" (click)="fileInput.click()" type="button">
                                    <i class="fi fi-rs-upload"></i>
                                    {{'employeeCard_btnUpload' | translate}}
                                </button>

                                <div class="text-danger mt-1" *ngIf="photo && photo.size > maxSize">
                                    {{'employeeCard_maxSizeError' | translate | formatString:[photo.size, maxSize]}}
                                </div>

                                <input #fileInput type="file" [accept]="accept" (change)="onPhotoChange($event)" style="display: none" />
                            </div>
                        </app-alert>

                        <div class="row" *ngIf="canPickPerson && isNew">
                            <div class="form-field required">
                                <label class="form-label">{{'employeeCard_lblEmployee' | translate}}</label>
                                <div class="input-group">
                                    <input class="form-control" [value]="person?.displayName" disabled required />
                                    <button class="btn btn-outline" type="button" (click)="togglePersonPicker()">
                                        <i class="fi fi-rs-pencil"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg form-field required">
                                <label class="form-label">{{'employeeCard_lblName' | translate}}</label>
                                <input class="form-control" formControlName="name">
                                <div class="invalid-feedback" *ngIf="form.get('name')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>

                            <div class="col-lg form-field required">
                                <label class="form-label">{{'employeeCard_lblSurname' | translate}}</label>
                                <input class="form-control" formControlName="surname">
                                <div class="invalid-feedback" *ngIf="form.get('surname')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg form-field required">
                                <label class="form-label">{{'employeeCard_lblStructure' | translate}}</label>
                                <input class="form-control" formControlName="structure">
                                <div class="invalid-feedback" *ngIf="form.get('structure')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>

                            <div class="col-lg form-field required">
                                <label class="form-label">{{'employeeCard_lblPosition' | translate}}</label>
                                <input class="form-control" formControlName="position">
                                <div class="invalid-feedback" *ngIf="form.get('position')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 form-field required">
                                <label class="form-label">{{'employeeCard_lblCardNumber' | translate}}</label>
                                <input class="form-control" formControlName="cardNumber">
                                <div class="invalid-feedback" *ngIf="form.get('cardNumber')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>

                            <div class="col-lg-6 form-field required" *ngIf="isAdmin">
                                <label class="form-label">{{'employeeCard_lblChipCode' | translate}}</label>
                                <input class="form-control" formControlName="chipCode">
                                <div class="invalid-feedback" *ngIf="form.get('chipCode')?.errors?.maxlength as ml">
                                    {{'fieldError_lengthMinMax' | translate | formatString:[1, ml.requiredLength]}}
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="form-actions">
                        <button class="btn btn-outline" type="button" (click)="close()" *ngIf="!isEdit">
                            {{'close' | translate}}
                        </button>

                        <button class="btn btn-outline" type="button" (click)="edit(true)" *ngIf="canEdit && !isEdit">
                            <i class="fi fi-rs-pencil"></i>
                            {{'edit' | translate}}
                        </button>

                        <button class="btn btn-outline" type="button" (click)="edit(false)" *ngIf="isEdit">
                            {{'cancel' | translate}}
                        </button>

                        <button class="btn btn-secondary" type="button" (click)="save()" [disabled]="!isValid" *ngIf="isEdit">
                            {{'employeeCard_btnSave' | translate}}
                        </button>

                        <button class="btn btn-primary" type="button" (click)="save(true)" [disabled]="!isValid" *ngIf="isEdit && canSubmit">
                            <i class="fi fi-rs-check"></i>
                            {{'employeeCard_btnSubmit' | translate}}
                        </button>

                        <button class="btn btn-outline" type="button" (click)="revoke()" *ngIf="canRevoke && !isEdit">
                            <i class="fi fi-rs-ban"></i>
                            {{'employeeCard_btnRevoke' | translate}}
                        </button>

                        <button class="btn btn-secondary" type="button" (click)="reject()" *ngIf="canReview && !isEdit">
                            <i class="fi fi-rs-cross"></i>
                            {{'employeeCard_btnReject' | translate}}
                        </button>

                        <button class="btn btn-primary" type="button" (click)="approve()" *ngIf="canReview && !isEdit">
                            <i class="fi fi-rs-check"></i>
                            {{'employeeCard_btnApprove' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
